import { COLOR } from '@src/styles/color';
import styled from 'styled-components';

export const StyledTabs = styled.div`
  display: flex;
  gap: ${({ styleTabs }) => styleTabs?.gap || '8px'};
  ${({ styleTabs }) => styleTabs};
`;

export const StyledTabItem = styled.div`
  padding: ${({ styleTab }) => styleTab?.padding || '8px 12px'};
  border-radius: ${({ styleTab }) => styleTab?.borderRadius || '8px'};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ styleTab }) => styleTab?.color || COLOR.label2[64]};
  background-color: ${({ styleTab }) =>
    styleTab?.backgroundColor || COLOR.white};

  &.active {
    background-color: ${({ styleTab }) =>
      styleTab?.activeBackgroundColor || COLOR.activeMenu};
    color: ${({ styleTab }) => styleTab?.activeColor || COLOR.darkGray};
    border-radius: ${({ styleTab }) => styleTab?.activeBorderRadius};
  }
  ${({ styleTab }) => styleTab};
`;
